export type BillingDocumentType = 'invoice' | 'offer';
export type BillingTextBlockType = 'intro' | 'paymentTerms' | 'closing';
export type BillingTextTemplateScope = 'company' | 'customer' | 'project';

export class BillingTextTemplateSearchReq {
    documentType: BillingDocumentType = 'invoice';
    buyerCompanyId?: number | null;
    projectId?: number | null;
}

export class BillingTextTemplateSaveReq {
    documentType: BillingDocumentType = 'invoice';
    blockType: BillingTextBlockType = 'intro';
    scopeType: BillingTextTemplateScope = 'company';
    name = '';
    content = '';
    paymentTermsDays?: number | null;
    paymentDiscountPercent?: number | null;
    paymentDiscountDays?: number | null;
    buyerCompanyId?: number | null;
    projectId?: number | null;
    isDefault = true;
}

export class BillingTextTemplateRes {
    id?: number | null;
    buyerCompanyId?: number | null;
    buyerCompanyName = '';
    projectId?: number | null;
    projectName = '';
    documentType: BillingDocumentType | '' = '';
    blockType: BillingTextBlockType = 'intro';
    scopeType = '';
    sourceLabel = '';
    name = '';
    content = '';
    paymentTermsDays?: number | null;
    paymentDiscountPercent?: number | null;
    paymentDiscountDays?: number | null;
    isDefault = false;
    isRecommended = false;
    readOnly = false;
    priority = 0;
}

export class BillingTextTemplateBundleRes {
    intro: BillingTextTemplateRes[] = [];
    paymentTerms: BillingTextTemplateRes[] = [];
    closing: BillingTextTemplateRes[] = [];
}
